import { Injectable, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { TelegramAuthService } from '@src/app/modules/telegram';
import { TelegramWebAppService } from '@src/app/modules/telegram-web-app';
import { AuthService } from '@src/app/modules/auth';
import { InternalMessengerService } from '@src/app/modules/internal-messenger';
import { logger } from '@src/utils';

import { LogoutModalComponent } from '../ui/logout-modal/logout-modal.component';
import { AUTO_RELOAD_PAGE_TIMER } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  private readonly internalMessengerService = inject(InternalMessengerService);
  private readonly telegramAuth = inject(TelegramAuthService);
  private readonly telegramWebAppService = inject(TelegramWebAppService);
  private readonly authService = inject(AuthService);
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);
  private readonly router = inject(Router);

  private timerId?: NodeJS.Timeout;

  private processing = false;

  private readonly dialog = this.dialogService.open<number>(
    new PolymorpheusComponent(LogoutModalComponent, this.injector),
    {
      size: 'm',
      closeable: false,
      dismissible: false,
    },
  );

  constructor() {
    logger('LogoutService constructor');

    this.telegramAuth.updates$.subscribe(update => {
      if (update._ === 'updateAuthorizationState' && this.processing) {
        const { authorizationState } = update;

        logger('LogoutService', authorizationState);

        if (authorizationState._ === 'authorizationStateClosed') {
          if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = undefined;
          }

          this.goToLogin();
        }
      }
    });
  }

  /**
   * Метод где выходим:
   * - из основной сессии пользователя
   * - из сессии Telegram (если мы авторизованы)
   */
  async logout(): Promise<void> {
    this.authService.logout();

    await this.internalMessengerService.logOut();

    if (this.telegramWebAppService.isRunAsTelegramWebApp()) {
      // Работаем из под Telegram бота
      this.telegramWebAppService.close();
      return;
    }

    if (this.telegramAuth.isLogged()) {
      this.processing = true;

      this.dialog.subscribe();
      await this.telegramAuth.logout();

      // Предохранитель, на случай, если Telegram не отвечает
      this.timerId = setTimeout(() => this.goToLogin(), AUTO_RELOAD_PAGE_TIMER);
    } else {
      this.goToLogin();
    }
  }

  private goToLogin() {
    this.router.navigate(['login']);
  }
}
